import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-main-spos',
  templateUrl: './main-spos.component.html',
  styleUrls: ['./main-spos.component.css'],
})
export class MainSposComponent {}
